/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `
   {{#product}}
   <a id="wishlist-product-{{index}}" href="{{du}}" aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <div class="swym-wishlist-image-wrapper">
       <img alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <div class="product_details">
       <div class="swym-category swym-title-1">
       {{#ct}}{{ct}}{{/ct}}{{^ct}}{{bt}}{{/ct}}
       </div>
       <h2 class="swym-title swym-title-1">
          {{dt}}
       </h2>
       <div class="swym-product-price swym-text swym-text-1">
         <div class="swym-product-final-price swym-value" data-price="{{pr}}" data-currency="{{cu}}">
           {{cu}} {{pr}}
         </div>
       </div>
     </div>


     <div class="wishlist-buttons">
       <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
         {{#isInCart}}{{labels.addedToCart}}{{/isInCart}}{{^isInCart}}{{labels.addToCart}}{{/isInCart}}
       </button>
       <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
         {{labels.removeFromList}}
       </button>
     </div>
   </a>
   {{/product}}`;

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");

  var addToCartItem = window.wishListItems.filter(item => item.empi.toString() === productId)[0];
  delete addToCartItem.empi

  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function (c) {
    e.target.innerHTML = "Added to Cart";
    e.target.setAttribute("data-state-cart", "swym-added");
    updateEcommerceDataLayer('add_to_cart', addToCartItem)
    console.log("Successfully added product to cart.", c);
  }, function (e) {
    console.log(e);
  });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");

  var removeFromListItem = window.wishListItems.filter(item => item.empi === empi)[0];
  delete removeFromListItem.empi

  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          updateEcommerceDataLayer('remove_from_wishlist', removeFromListItem)
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}

function swymRenderWishlist(swat) {
  window.itemList = []
  window.wishListItems = []
  // Get wishlist items
  swat.fetch(function (products) {
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");

    if (wishlistContentsContainer) {
      if (!ShopifyAnalytics.meta.page.customerId) {
        wishlistContentsContainer.innerHTML = `<div class="swym-error-container">Per accedere alla wishlist devi essere registrato e loggato</div>`
        return
      }

      window.scrollTo(0, 0)
      wishlistContentsContainer.innerHTML = ""
      var formattedWishlistedProducts = products.map(function (p, index) {
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");

        window.itemList.push(
          {
            item_id: p.id,
            item_name: p.dt,
            affiliation: "Pisa 1940",
            coupon: "",
            currency: ShopifyAnalytics.meta.currency,
            discount: "",
            index,
            item_brand: p.bt || "",
            item_category: p.ct || "",
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: 'wishlist',
            item_list_name: 'Wishlist',
            item_variant: ""
          });

        return p;
      });

      window.wishListItems = itemList.map(item => {
        return {
          ...item,
          empi: formattedWishlistedProducts[item.index].empi,
          price: formattedWishlistedProducts[item.index].pr
        }
      })

      const quantity = `${formattedWishlistedProducts.length} ${formattedWishlistedProducts.length == 1 ? wishlistContentsContainer.dataset.quantityOne : wishlistContentsContainer.dataset.quantityMany}`
      wishlistContentsContainer.insertAdjacentHTML('beforeend', `<div class="swym-wishlist-grid"><div class="product-quantity">${quantity}</div>`)
      formattedWishlistedProducts.forEach((formattedWishlistedProduct, index) => {
        var renderedProductTile = SwymUtils.renderTemplateString(productCardMarkup, {
          product: formattedWishlistedProduct,
          index,
          labels: {
            addToCart: wishlistContentsContainer.dataset.addToCart,
            addedToCart: wishlistContentsContainer.dataset.addedToCart,
            removeFromList: wishlistContentsContainer.dataset.removeFromList
          }
        });
        wishlistContentsContainer.querySelector(".swym-wishlist-grid").insertAdjacentHTML('beforeend', renderedProductTile);

        let prices = wishlistContentsContainer.querySelectorAll('.swym-product-final-price');
        prices.forEach((el) => {
          let price = el.dataset.price
          // let currency = el.dataset.currency

          el.innerHTML = currencySign(price);
        });
      })

      wishlistContentsContainer.insertAdjacentHTML('beforeend', '</div>')

      attachClickListeners();
      if (window.itemList.length > 0) {
        updateEcommerceDataLayer('view_item_list', window.itemList)
      }
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

const euroPrice = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

function currencySign(price) {
  let str = euroPrice.format(price)
  return str.substr(str.length - 1) + str.substr(0, str.length - 1);
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
